import { css } from '@emotion/core';
import { unset } from 'lodash';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../../utils/constants';

export const stopAnimation = transformValue =>
  css({
    '.swiper-wrapper': {
      transitionDuration: '0ms !important',
      transform: 'translate3d(' + transformValue + 'px, 0px, 0px) !important',
    },
  });

export const homepageSlide = css({
  width: 'calc(100% + 78px)',
  position: 'relative',
  [MediaQueries.md]: {
    width: '100%',
  },

  [MediaQueries.sm]: {
    width: '100%',
  },

  '.swiper-pagination': {
    display: 'flex',
    justifyContent: 'center',
    '.swiper-pagination-bullet-active': {
      background: '#E52500',
    },
  },

  '.shadowslide': {
    height: '429px',
    zIndex: '9',
    right: '0',
    width: '270px',
    display: 'none',
    position: 'absolute',
    background:
      'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
  },

  '.swiper-wrapper': {
    boxSizing: 'inherit',
    transitionTimingFunction: 'linear',
    // [MediaQueries.sm]: {

    // },
  },

  '&:hover': {
    '.regus-button-prev': {
      display: 'block',
      [MediaQueries.sm]: {
        display: 'none',
      },
      [MediaQueries.md]: {
        // display: 'none',
      },
    },
    '.regus-button-next': {
      display: 'block',
      [MediaQueries.sm]: {
        display: 'none',
      },
      [MediaQueries.md]: {
        // display: 'none',
      },
    },
  },

  '.swiper-slide': {
    width: '304px',
    height: '472px',
    [MediaQueries.lg]: {
      width: '296px',
    },

    [MediaQueries.md]: {
      width: '304px',
    },

    [MediaQueries.sm]: {
      width: '304px',
    },
  },

  '.swiper-container': {
    overflow: 'inherit',
    [MediaQueries.md]: {
      overflow: 'inherit',
    },
    [MediaQueries.sm]: {
      overflow: 'inherit',
    },

    '.regus-button-prev': {
      display: 'none',
    },
    '.regus-button-next': {
      display: 'none',
    },
  },

  '.swiper-container:hover': {
    '.regus-button-prev': {
      display: 'block',
      [MediaQueries.sm]: {
        display: 'none',
      },
    },
    '.regus-button-next': {
      display: 'block',
      [MediaQueries.sm]: {
        display: 'none',
      },
    },
  },

  '.regus-button-prev': {
    position: 'absolute',
    bottom: '45%',
    zIndex: 1,
    cursor: 'pointer',
    display: 'none',
    border: '0',
    outline: '0px',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.12)',
    backgroundColor: '#fff',
    left: '-25px',
    [MediaQueries.lg]: {
      right: '80px',
    },
  },

  '.regus-button-next': {
    position: 'absolute',
    bottom: '45%',
    cursor: 'pointer',
    display: 'none',
    zIndex: 1,
    width: '48px',
    boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.12)',
    height: '48px',
    borderRadius: '50%',
    outline: '0px',
    border: '0',
    backgroundColor: '#fff',
    // right: '48px',
    transform: 'translateX(50%)',
    right: 78,
    [MediaQueries.sm]: {
      right: 0,
    },
    [MediaQueries.md]: {
      // right: '85px',
      right: 0,
    },
    [MediaQueries.lg]: {
      // right: '158px',
    },
  },
});
